// import axios from 'axios';

// // Base URL for your API
// const API_URL = 'https://192.168.1.244:7775/api/'; 
// const userData = localStorage.getItem('user');
// const parsedUserData = userData ? JSON.parse(userData) : null;

// if (!parsedUserData) {
//   console.log('JWT Token not found in localStorage');
//   // Handle the case where there is no userData, e.g., redirect to login
// }
// // Create an Axios instance with default configuration
// const apiClient = axios.create({
//   baseURL: API_URL,
//   headers: {
//     'wg_token': parsedUserData,  // The custom header with JWT token
//     'Content-Type': 'application/json',  // Default headers for requests
//   },
// });

// // Request Interceptor - Adding Authorization Header (e.g., JWT Token)
// apiClient.interceptors.request.use(
//   (config) => {
//     // Get DATABASENAME from localStorage
//     // const databaseName = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')).DBNAME : 'defaultDB';
//     config.headers['wg_token'] = parsedUserData;
//     // Add the DATABASENAME to the request params
//     // if (config.params) {
//     //   config.params.DATABASENAME = databaseName;
//     // } else {
//     //   config.params = { DATABASENAME: databaseName };
//     // }

//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// apiClient.interceptors.response.use(
//   (response) => {
//     // This will be executed for successful responses (status code 2xx)
//     return response;
//   },
//   (error) => {
//     // This will be executed for failed responses (status code 4xx, 5xx, etc.)
//     if (error.response) {
//       const { status, data } = error.response;
      
//       // Handle specific HTTP errors globally
//       switch (status) {
//         case 401:
//           // Handle Unauthorized (e.g., logout user)
//           // store.dispatch(logoutUser()); // Dispatch logout action to Redux store
//           // Optionally redirect to login page
//           break;
//         case 403:
//           // Handle Forbidden error
//           console.error('You do not have permission to access this resource.');
//           break;
//         case 404:
//           // Handle Not Found error
//           console.error('Resource not found. Please check the PO number or vehicle number.');
//           break;
//         case 500:
//           // Handle Internal Server Error
//           console.error('Server error. Please try again later.');
//           break;
//         default:
//           // General error handling (e.g., network errors)
//           console.error('Something went wrong. Please try again later.');
//       }

//       // You can throw the error with a custom message for further processing if needed
//       const errorMessage = data?.message || 'An error occurred while processing your request';
//       return Promise.reject(new Error(errorMessage)); // Reject with a specific error message
//     } else if (error.request) {
//       // No response was received (e.g., network issue)
//       console.error('No response from the server. Please check your internet connection.');
//       return Promise.reject(new Error('No response from server'));
//     } else {
//       // Other errors (e.g., errors in setting up the request)
//       console.error('Request error: ', error.message);
//       return Promise.reject(new Error('An error occurred during the request.'));
//     }
//   }
// );
// // // Response Interceptor - Handling Errors Globally
// // apiClient.interceptors.response.use(
// //   (response) => {
// //     return response;  // If the response is successful, return it
// //   },
// //   (error) => {
// //     // Global error handling
// //     if (error.response) {
// //       const { status } = error.response;
// //       if (status === 401) {
// //         // Handle unauthorized access (e.g., redirect to login)
// //         console.error('Unauthorized, redirecting to login...');
// //       }
// //       // Other status code handling (404, 500, etc.)
// //     } else {
// //       console.error('Network Error');
// //     }
// //     return Promise.reject(error);  // Reject the error so that the caller can handle it
// //   }
// // );

// export default apiClient;


import axios from 'axios';
import { useEffect, useState } from 'react';

// Base URL for your API
const API_URL = process.env.REACT_APP_API_BASE_URL;
const environment = process.env.REACT_APP_ENVIRONMENT;
console.log("Environment:", environment);

// Create an Axios instance with default configuration
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',  // Default headers for requests
  },
});

// Hook to load user data and update the token dynamically
const useApiClient = () => {
  const [isTokenSet, setIsTokenSet] = useState(false);

  useEffect(() => {
    const userData = sessionStorage.getItem('user');
    const parsedUserData = userData ? JSON.parse(userData) : null;

    if (parsedUserData) {
      // Update the token dynamically when available
      apiClient.defaults.headers['wg_token'] = parsedUserData;
      setIsTokenSet(true); // Indicate the token is set
    }
  }, []); // Run only once on component mount

  return { isTokenSet };
};

// This is where the hook is used inside a React component
const YourComponent = () => {
  const { isTokenSet } = useApiClient();

  // You can use the apiClient here if needed
  useEffect(() => {
    if (isTokenSet) {
    }
  }, [isTokenSet]);

  return <div>Your Component</div>;
};

apiClient.interceptors.request.use(
  (config) => {
    const userData = sessionStorage.getItem('user');
    const parsedUserData = userData ? JSON.parse(userData) : null;
    const isLoginEndpoint = config.url?.toLowerCase().includes('login');

    if (!parsedUserData && !isLoginEndpoint) {
      console.warn('Blocked request: missing token and not login');
      throw new axios.Cancel('Request cancelled: Token missing');
    }

    if (parsedUserData) {
      config.headers['wg_token'] = parsedUserData;
    }


    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isCancel(error)) {
      return Promise.resolve(); // or suppress silently
    }

    if (error.response) {
      const { status, data } = error.response;
      if (status === 401) {
        console.error('Unauthorized: Token invalid or expired');
      } else {
        console.error('API error:', data?.message);
      }
    }

    return Promise.reject(error);
  }
);

export default apiClient;
export { useApiClient, YourComponent };
